import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../../components/UI/Table/Table';
import SearchBar from '../../../components/UI/SearchBar/SearchBar';
import Blank from '../../../hoc/Blank/Blank';
import Spinner from '../../../components/UI/Spinner/Spinner';
import 'react-toastify/dist/ReactToastify.min.css' ;
import { ToastContainer,toast } from 'react-toastify';

import * as actions from '../../../store/actions/index';

class AdminCallList extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
    let scoutsLastGot = new Date('2019-01-12 11:00:00');
    if (this.props.scoutsLastGot) {
      scoutsLastGot = this.props.scoutsLastGot;
    }
        let current = new Date();
        let diffMs = (current - scoutsLastGot);
        let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
        if (diffMins > 3) {
          this.props.onGetScouts();
        }
      this.props.onInit();
      this.props.onInitOrder();
  }

  state = {
    showEditOrder: false,
    showSuccess: false,
    orderId: 0,
    width: window.innerWidth,
    callListOrder: null,
    purchased: false,
    searched: false,
    result: null
  }

  componentDidUpdate(prevProps) {
      
    if (this.props.result != "0") {
      let message = "The order was successfully added.";
      if ( this.props.result == "updated") {
         message = "The order was successfully updated.";
      }
      if (!this.state.result || this.state.result != this.props.result  ) {
        this.setState({result:this.props.result});
        toast(message);
      }
    }
    this.props.onInitOrder();
}

  cancelEditOrderHandler = () => {
    this.setState({ showEditOrder: false, showSuccess: false, purchased: false, orderId: 0, callListOrder: null, purchase: false });
  }


  DataChanged = (value) => {
         
    this.props.onUpdateSearchCriteria(value);
  }

  search = () => {
this.props.onSearch();
    
  }

  showOrder = (e) => {
    this.setState({result:""});
    
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/adminEditOrder?' + oid);
  }


  render() {

    if (this.props.orders && this.props.orders.length) {

      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
      }

      let i = -1;

      for (let k1 in this.props.orders) {
        let order = this.props.orders[k1]

        data.push({
          oid: order.orderId, data: [{
            value: order.orderId,
            style: { paddingLeft: pl, width: seventyFive },
            full: false
          },
          {
            value: order.name,
            style: { width: oneFifty, paddingLeft: pl },
            full: false
          },
          {
            value: order.address,
            style: { width: "250px", paddingLeft: pl },
            full: true
          },
          {
            value: order.phone,
            style: { width: seventyFive, paddingLeft: pl },
            full: true
          },
          {
            value: order.email,
            style: { width: oneFifty, paddingLeft: pl },
            full: true
          }]})

          i = i + 1

        if (this.props.mulchYear.sellHardwood) {
          data[i].data.push(
          {
            value: order.hardwoodBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellCedar) {
          data[i].data.push(
          {
            value: order.cedarBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellBlack) {
          data[i].data.push(
          {
            value: order.blackBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }
        
        if (this.props.mulchYear.sellRed) {
          data[i].data.push(
          {
            value: order.redBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        data[i].data.push(
          {
            value: order.lastMulchYear,
            style: { width: seventyFive, paddingLeft: pl },
            full: true
          }
        );
        }


      var header = [{
        name: "Order",
        style: { paddingLeft: pl, width: seventyFive }
      },
      {
        name: "Name",
        style: { width: oneFifty, paddingLeft: pl }
      },
      {
        name: "Address",
        style: { width: "250px", paddingLeft: pl },
        full: true
      },
      {
        name: "Phone",
        style: { width: seventyFive, paddingLeft: pl },
        full: true
      },
      {
        name: "Email",
        style: { width: oneFifty, paddingLeft: pl },
        full: true
      }]

      if (this.props.mulchYear.sellHardwood) {
        header.push(
      {
        name: "Hwd",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: { width: fifty, paddingLeft: pl }
      })
    }
    header.push(
      {
        name: "Last Year",
        style: { width: seventyFive, paddingLeft: pl },
        full: false
      }
    );

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          <SearchBar onSearch={this.search} onDataChanged={this.DataChanged}/>  
          <Table header={header} data={data} editPopupHandler={this.showOrder}></Table>
        </Blank>
      );
    }
    else if (this.props.loading) {
      return (
        <div>
                <SearchBar onSearch={this.search} onDataChanged={this.DataChanged}/> 
                <Spinner />
        </div>
      );
    }
    else {
      return (
        <div>
                <SearchBar onSearch={this.search} onDataChanged={this.DataChanged}/> 
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    searchCriteria: state.orders.searchCriteria,
    orders: state.orders.searchResults,
    loading: state.orders.loading,
    submitted: state.orders.submitted,
    scoutsLastGot: state.orders.scoutsLastGot
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onInitOrder: () => dispatch(actions.initOrder()),
    onGetScouts:() => dispatch(actions.getScouts()),
    onInit: () => dispatch(actions.initSearchResults()),
    onSearch: () => dispatch(actions.searchAdminCallList()),
    onUpdateSearchCriteria:(searchCriteria) => dispatch(actions.updateSearchCriteria(searchCriteria))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminCallList);


// WEBPACK FOOTER //
// ./src/containers/Orders/AdminCallList/AdminCallList.js